import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  modalContainer: ({ spacing, colors }) => css`
    padding: ${spacing.sm} 0;

    > p {
      margin-top: ${spacing.sm};
      color: ${colors.neutral[500]};
    }

    > div {
      display: flex;
    }
    section {
      margin-top: 32px;
    }
  `,

  containerLink: ({ spacing }) => css`
    padding: 0 ${spacing.xxs};
    display: flex;
    flex-direction: column;
    gap: ${spacing.xxs};
  `,
})

export default useStyles
